import { render, staticRenderFns } from "./CapturaDocumento.vue?vue&type=template&id=58a96d80&scoped=true&"
import script from "./CapturaDocumento.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumento.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumento.vue?vue&type=style&index=0&id=58a96d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a96d80",
  null
  
)

export default component.exports